


































































































import Vue from 'vue';
import UtenteLoggedMenu from '@/components/selectors/UtenteLoggedMenu.vue';
import { mapActions } from 'vuex';

export default Vue.extend({
    data: () => {
        return {
            hasNavMenu: false,
        };
    },
    components: {
        UtenteLoggedMenu,
    },
    props: {
        working: { type: Boolean, required: true },
        isAuthenticated: { type: Boolean, required: true },
    },
    computed: {
        appName() {
            return process.env.VUE_APP_NAME;
        },
    },
    methods: {
        ...mapActions(['toggleDrawer', 'closeDrawer']),
    },
    watch: {
        $route: {
            handler: function () {
                this.hasNavMenu =
                    this.$router.currentRoute.matched[0].components
                        .navigation !== undefined;
            },
            immediate: true,
            deep: true,
        },
    },
});
